import React, { useEffect, useMemo, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { HugeiconsIcon } from "@hugeicons/react";
import { ShoppingCart02Icon } from "@hugeicons/core-free-icons";
import CategoriesBar from "../components/homeComponents/CategoriesBar";
import { getPublicStoreSettings } from "../Redux/Actions/storeSettingActions";

import "./layout.css";
import "./header.css";

const Header = () => {
  const [keyword, setKeyword] = useState("");
  const history = useHistory();
  const dispatch = useDispatch();

  const cart = useSelector((state) => state.cart || {});
  const { cartItems = [] } = cart;

  const publicStoreSettings = useSelector(
    (state) => state.publicStoreSettings || {}
  );
  const { settings = {} } = publicStoreSettings;

  useEffect(() => {
    dispatch(getPublicStoreSettings());
  }, [dispatch]);

  const whatsappUrl = useMemo(() => {
    const whatsappNumber = String(settings?.whatsappNumber || "").trim();

    if (!whatsappNumber) return "";

    const message = "Hola, me gustaría recibir asesoría para realizar una compra. ¿Me puedes orientar, por favor?";

    return `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
  }, [settings]);

  const submitHandler = (e) => {
    e.preventDefault();
    const q = keyword.trim();

    if (q) history.push(`/search/${q}`);
    else history.push("/");
  };

  const handleAdvisorClick = (e) => {
    if (!whatsappUrl) {
      e.preventDefault();
      alert("No hay un número de WhatsApp configurado en este momento.");
    }
  };

  return (
    <div>
      <div className="Announcement">
        <div className="site-shell">
          <div className="site-shell-inner">
            <div className="row">
              <div className="col-md-6 d-flex align-items-center display-none">
                <p>Atención personalizada y compra fácil por WhatsApp</p>
              </div>

              <div className="col-12 col-lg-6 justify-content-center justify-content-lg-end d-flex align-items-center header-social">
                <a
                  href="https://www.instagram.com/altamoda17.valledupar/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-instagram"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="header">
        <div className="site-shell">
          <div className="site-shell-inner">
            <div className="mobile-header">
              <div className="row">
                <div className="col-6 d-flex align-items-center">
                  <Link className="navbar-brand" to="/">
                    <img alt="logo" src="/images/LogoHeader.png" />
                  </Link>
                </div>

                <div className="col-6 d-flex align-items-center justify-content-end Login-Register">
                  <Link to="/cart" className="cart-mobile-icon">
                    <HugeiconsIcon
                      icon={ShoppingCart02Icon}
                      size={20}
                      className="cart-icon"
                      color="#000000"
                    />
                    <span className="badge">{cartItems.length}</span>
                  </Link>
                </div>

                <div className="col-12 d-flex align-items-center mb-1 justify-content-center">
                  <form onSubmit={submitHandler} className="input-group">
                    <input
                      type="search"
                      className="form-control search"
                      placeholder="¿Qué está buscando?"
                      value={keyword}
                      onChange={(e) => setKeyword(e.target.value)}
                    />
                    <button type="submit" className="search-button">
                      <ion-icon name="search-outline"></ion-icon>
                    </button>
                  </form>
                </div>
              </div>
            </div>

            <div className="pc-header">
              <div className="row">
                <div className="col-md-3 col-4 d-flex align-items-center">
                  <Link className="navbar-brand" to="/">
                    <img alt="logo" src="/images/LogoHeader.png" />
                  </Link>
                </div>

                <div className="col-md-6 col-8 d-flex align-items-center justify-content-center">
                  <form onSubmit={submitHandler} className="input-group">
                    <input
                      type="search"
                      className="form-control search"
                      placeholder="¿Qué está buscando?"
                      value={keyword}
                      onChange={(e) => setKeyword(e.target.value)}
                    />
                    <button type="submit" className="search-button">
                      <ion-icon
                        name="search-outline"
                        style={{ fontSize: "20px" }}
                      ></ion-icon>
                    </button>
                  </form>
                </div>

                <div className="col-md-3 d-flex align-items-center justify-content-end Login-Register">
                  <a
                    href={whatsappUrl || "#"}
                    onClick={handleAdvisorClick}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ marginRight: "16px", color: "#000000" }}
                  >
                    Asesoría por WhatsApp
                  </a>

                  <Link to="/cart" className="cart-desktop-icon">
                    <HugeiconsIcon
                      icon={ShoppingCart02Icon}
                      size={25}
                      className="cart-icon"
                      color="#000000"
                    />
                    <span className="badge">{cartItems.length}</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CategoriesBar />
    </div>
  );
};

export default Header;